import { NOTES_RAIL_DEMO_NOTES } from './notesRailDemoNotes'

/** @typedef {import('../lib/types.js').NotesRailNoteWire} NotesRailNoteWire */

/** @returns {NotesRailNoteWire[]} */
export function getNotesRailDemoData() {
  return NOTES_RAIL_DEMO_NOTES
}

/** @returns {Array<{ id: string, title: string }>} */
export function getNotesAsThreadNavItems() {
  return getNotesRailDemoData().map((n) => ({
    id: n.id,
    title: String(n.title ?? '').trim() || 'Untitled',
  }))
}

/** @param {string | null | undefined} threadId */
export function isNoteBackedThreadId(threadId) {
  if (threadId == null || threadId === '') return false
  return getNotesAsThreadNavItems().some((n) => n.id === threadId)
}
